import { IonCard, IonCardHeader, IonCardTitle, IonCardContent, IonCol } from "@ionic/react";
import { CalculatorFormTrocutResult } from "./FormTypes";
import { useTranslation } from "react-i18next";

interface TrocutResultCardProps {
    isCardShowing: boolean;
    result: null | CalculatorFormTrocutResult
}

const TrocutResultCard: React.FC<TrocutResultCardProps> = ({ isCardShowing, result }: TrocutResultCardProps) => {
    const { t } = useTranslation();

    const cardContent = () => {
        if (result === null) {
            return (
                <div>
                    <p>{t("calculatorForm.ResultCard.Kein Ergebnis Fehler")}</p>
                </div>
            )
        } else {
            return (
                <div>
                    <table className="calculatorResultTable">
                        <tbody>
                            <tr>
                                <td><b>h<sub>max</sub></b> (max. {t("calculatorForm.ResultCard.Spandicke")})</td>
                                <td>{result.hmax.toFixed(3).toLocaleString()} mm</td>
                            </tr>
                            <tr>
                                <td><b>f<sub>z</sub></b> ({t("calculatorForm.ResultCard.Zahnvorschub")})</td>
                                <td>{result.fz_tro.toFixed(3).toLocaleString()} mm</td>
                            </tr>
                            <tr>
                                <td><b>v<sub>c</sub></b> ({t("calculatorForm.ResultCard.Schnittgeschw.")})</td>
                                <td>{result.vc_tro.toLocaleString()} m/min</td>
                            </tr>
                            <tr>
                                <td><b>&#946;<sub>min</sub></b> (min. {t("calculatorForm.ResultCard.Eingriffswinkel")})</td>
                                <td>{result.pressureAngleMin.toFixed(1).toLocaleString()} °</td>
                            </tr>
                            <tr>
                                <td><b>&#946;<sub>max</sub></b> (max. {t("calculatorForm.ResultCard.Eingriffswinkel")})</td>
                                <td>{result.pressureAngleMax.toFixed(1).toLocaleString()} °</td>
                            </tr>
                            <tr>
                                <td><b>a<sub>e</sub> {t("calculatorForm.ResultCard.für")} &#946;<sub>min</sub></b></td>
                                <td>{result.aePressureAngleMin.toFixed(3).toLocaleString()} mm</td>
                            </tr>
                            <tr>
                                <td><b>a<sub>e</sub> {t("calculatorForm.ResultCard.für")} &#946;<sub>max</sub></b></td>
                                <td>{result.aePressureAngleMax.toFixed(3).toLocaleString()} mm</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            )
        }

    }

    if (isCardShowing) {
        return (
            <IonCol size="12">
                <IonCard>
                    <IonCardHeader>
                        <IonCardTitle>{t("calculatorForm.ResultCard.Ergebnis")}</IonCardTitle>
                    </IonCardHeader>
                    <IonCardContent>
                        {cardContent()}
                    </IonCardContent>
                </IonCard>
            </IonCol>
        )
    }
    return (
        null
    )
}

export default TrocutResultCard;